import Vue from 'vue';
import Vuex from 'vuex';
// 使用 vuex-persistedstate 維持Vuex狀態(解決頁面刷新後，Vuex的store所有資料回到初始狀態問題)
import createPersistedState from "vuex-persistedstate";
import SecureLS  from 'secure-ls';
import identidyOpenStatus from "./modules/identidyOpenStatus";
import identidyInfo from "./modules/identidyInfo";
import identidyInputVerification from "./modules/identidyInputVerification";
import identidySms from "./modules/identidySms";
import identidyOpenResult from "./modules/identidyOpenResult";
import todayScheduleList from "./modules/todayScheduleList";
import scheduleDetailData from "./modules/scheduleDetailData";

const ls = new SecureLS({
	encodingType: "aes", // 加密方式
	isCompression: false, // 是否壓縮
});

Vue.use(Vuex);


const store = new Vuex.Store({
    modules: {
        identidyOpenStatus,
        identidyInfo,
        identidyInputVerification,
        identidySms,
        identidyOpenResult,
        todayScheduleList,
        scheduleDetailData,
    },
    plugins: [createPersistedState({
        // 設定保存在sessionStorage
        key: 'OPS',
		storage: {
			getItem: key => {
                try{
                    // console.log("getitem",ls,key);
                    // console.log('getitem=',ls.get(key));
                    return ls.get(key)
                }catch(err){
                    localStorage.clear();
                    // console.log("err",err);
                    return null;
                }
                // return ls.get(key)
            },
			setItem: (key, value) => {
                // console.log("setItem",key,value);
               return  ls.set(key, value)
            },
			removeItem: key => ls.remove(key)
		}
    })]
});

export default store;